import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function MiniProgramGovContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  miniProgramGovId,
  showMiniProgramGov,
  miniProgramGovInfo,
}) {

  useEffect(() => {
    if (_.isEmpty(miniProgramGovId)) return;
    showMiniProgramGov(miniProgramGovId);
  }, [miniProgramGovId]);

  const renderStatus = (status) => {
    if (status) {
      return <div className="btn btn-sm btn-success">ACTIVE</div>;
    }
    return <div className="btn btn-sm btn-danger">INACTIVE</div>;
  };

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(miniProgramGovInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-9">
                  <h3 className="">
                    {_.get(miniProgramGovInfo, 'attributes.name') || '--'}
                  </h3>
                </div>
                <div className="col-3 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(miniProgramGovInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(miniProgramGovInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-4">
                    <img
                      className="w-100 rounded"
                      src={
                        !_.isObject(
                          _.get(miniProgramGovInfo, 'attributes.icon_url') || ''
                        )
                          ? _.get(miniProgramGovInfo, 'attributes.icon_url') ||
                            ImagePlaceholder
                          : _.get(miniProgramGovInfo, 'photo.cdnUrl') ||
                            ImagePlaceholder
                      }
                      alt=""
                    />
                  </div>
                  <div className="col">
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <th className="table-title">Name:</th>
                          <td>
                            {_.get(miniProgramGovInfo, 'attributes.name') || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Status:</th>
                          <td>
                            {renderStatus(
                              _.get(miniProgramGovInfo, 'attributes.is_active')
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Sequence:</th>
                          <td>
                            {_.get(miniProgramGovInfo, 'attributes.sequence') ||
                              '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Description:</th>
                          <td>
                            {_.get(miniProgramGovInfo, 'attributes.description') ||
                              '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Type:</th>
                          <td>
                            {_.get(
                              miniProgramGovInfo,
                              'attributes.type'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <a href={_.get(miniProgramGovInfo, 'attributes.redirect_url' || '--')}>
                            <th className="table-title">Redirect Link</th>
                          </a>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

MiniProgramGovContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  showMiniProgramGov: PropTypes.instanceOf(Function).isRequired,
  miniProgramGovInfo: PropTypes.instanceOf(Object).isRequired,
  miniProgramGovId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  miniProgramGovInfo: _.get(api, `${c.GET_SINGLE_MINI_PROGRAM_GOV}.item`) || {},
  miniProgramGovId: _.get(match, 'params.miniProgramGovId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MiniProgramGovContent);
